export default "__VITE_ASSET__BM8ShN1X__"